import axios from "@/helpers/axios";

const base_url = process.env.VUE_APP_API_BASEURL;

async function list(params) {
  return axios.get(`${base_url}oem-b2b`, { params }).then((response) => {
    return response.data;
  });
}

async function show(params) {
  return axios.get(`${base_url}oem-b2b/${params.id}`).then((response) => {
    return response.data;
  });
}

async function add(params) {
  return axios
    .post(`${base_url}oem-b2b`, params, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    });
}

async function update(params) {
  return axios
    .post(
      `${base_url}oem-b2b/${params.id}`,{ ...params, _method: "put" },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((response) => {
      return response.data.body;
    });
}

async function destroy(params) {
  return axios
    .delete_method(`${base_url}oem-b2b/${params.id}`, params)
    .then((response) => {
      return response.data.body;
    });
}

export default {
  list,
  show,
  add,
  update,
  destroy,
};
